import type { ReceiptTemplate } from '../schema';

export const familyDollarTemplate: ReceiptTemplate = {
  id: 'family-dollar',
  name: 'Family Dollar Receipt',
  brand: 'FAMILY DOLLAR',
  description: 'Family Dollar discount store receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'fd-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: 'FAMILY DOLLAR',
        businessNameFontSize: 16,
        addressLines: [
          'STORE #4892',
          '1200 DARK AVENUE',
          'MONSTERVILLE, CA 94608',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'fd-datetime',
      type: 'datetime',
      enabled: true,
      config: {
        alignment: 'center',
        dateTime: new Date().toISOString(), format: 'MM/DD/YYYY hh:mm A',
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'fd-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'PAPER TOWELS', quantity: '1', price: '3.00', sku: '' },
          { id: '2', name: 'DISH SOAP', quantity: '1', price: '2.00', sku: '' },
          { id: '3', name: 'SNACKS CHIPS', quantity: '2', price: '1.25', sku: '' },
          { id: '4', name: 'SODA 2-LITER', quantity: '1', price: '1.75', sku: '' },
          { id: '5', name: 'BATTERIES AA 4PK', quantity: '1', price: '4.00', sku: '' },
        ],
        showQuantity: true,
        showSku: false,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'fd-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '13.25', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '1.09', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '14.34', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'fd-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        method: 'CASH',
        fields: [
          { id: 'tend', label: 'CASH TEND:', value: '15.00' },
          { id: 'change', label: 'CHANGE:', value: '0.66' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'fd-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'THANK YOU FOR SHOPPING\nFAMILY DOLLAR',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};

